import React from 'react';

import { useParams } from 'react-router-dom';

import { Checkbox, FormLabel } from '@mui/material';
import useFeatureFlags from 'api/useFeatureFlags';
import { Coupon } from 'common/contracts';
import { EFeatureFlag } from 'constants/enums';
import { FormikErrors, FormikTouched } from 'formik';

import Input from 'components/Input/Input';

import { CouponFormValues } from '../../../types';

import CouponsAllowedPlayersTable from './CouponsAllowedPlayersTable';

interface PlayerSettingCouponsProps {
  couponFormValues: CouponFormValues;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  errors: FormikErrors<Coupon>;
  touched: FormikTouched<Coupon>;
  setFieldValue: (field: string, value: any) => void;
  dup: boolean;
}

export default function CouponsPlayerSettings({
  couponFormValues,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  dup
}: PlayerSettingCouponsProps) {
  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });

  const showAllowedPlayers =
    featureFlags?.[
      EFeatureFlag.COUPONS_ALLOWED_PLAYERS
    ];

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 gap-5 w-full">
        <div className="flex flex-col">
          <Input
            label="Max Coupon Redemptions Per Player"
            name="maxRedemptionsPerCustomer"
            value={couponFormValues.maxRedemptionsPerCustomer}
            disabled={couponFormValues.firstTimePurchase}
            onChange={handleChange}
            placeholder="Unlimited"
            onBlur={handleBlur}
            type="number"
            state={
              Boolean(errors.maxRedemptionsPerCustomer) &&
              (touched.maxRedemptionsPerCustomer || dup)
                ? 'error'
                : 'default'
            }
            description={
              touched.maxRedemptionsPerCustomer || dup
                ? errors.maxRedemptionsPerCustomer?.toString()
                : ''
            }
            className="w-[323px]"
          />
          <div className="flex items-center">
            <Checkbox
              checked={!!couponFormValues.firstTimePurchase}
              onClick={(e) => {
                setFieldValue(
                  'firstTimePurchase',
                  !couponFormValues.firstTimePurchase
                );
              }}
              name="active"
              data-testid="limit-to-first-time-buyers-checkbox"
              sx={{
                marginLeft: '-10px',
                '&.Mui-checked': {
                  color: 'hsl(var(--base-foreground))'
                }
              }}
            />
            <FormLabel
              sx={{
                cursor: 'pointer',
                color: 'hsl(var(--base-foreground))',
                fontSize: '14px'
              }}
              onClick={() => {
                setFieldValue(
                  'firstTimePurchase',
                  !couponFormValues.firstTimePurchase
                );
              }}
            >
              Limit To First Time Buyers
            </FormLabel>
          </div>
        </div>
      </div>
      {showAllowedPlayers && (
        <div className="mt-3">
          <CouponsAllowedPlayersTable
            couponFormValues={couponFormValues}
            setFieldValue={setFieldValue}
          />
        </div>
      )}
    </div>
  );
}
